export default __webpack_public_path__ + "static/media/drop-yellow.5ba7d116.svg";